import { headerBlock } from './header.js';
import { heroBlock } from './hero.js';
import { contentBlock } from './content.js';
import { featuresBlock } from './features.js';
import { pricingBlock } from './pricing.js';
import { testimonialsBlock } from './testimonials.js';
import { statsBlock } from './stats.js';
import { faqBlock } from './faq.js';
import { footerBlock } from './footer.js';
import { ctaBarBlock } from './cta-bar.js';
import { countdownBlock } from './countdown.js';
import { mapsBlock } from './maps.js';
import { logosBlock, catalogoBlock } from './logos.js';
import { ofertasBlock, novedadesBlock, topBlock, habitualBlock } from './tienda.js';
import { teamBlock } from './team.js';
import { timelineBlock } from './timeline.js';
import { videoBlock } from './video.js';
import { galleryBlock } from './gallery.js';
import { carruselBlock } from './carrusel.js';
import { processBlock } from './process.js';
import { beforeAfterBlock } from './before-after.js';
import { bannerBlock } from './banner.js';
import { comparisonBlock } from './comparison.js';
import { bentoBlock } from './bento.js';
import { journeyBlock } from './journey.js';
import { aiCustomBlock } from './ai-custom.js';
import { formBlock } from './form.js';
import { reservasBlock } from './reservas.js';
import { reservaLiveBlock } from './reserva-live.js';
import { entradasBlock } from './entradas.js';
import { menuBlock } from './menu.js';
import { servicesBlock } from './services.js';
import { trustBlock } from './trust.js';
import { reviewsBlock } from './reviews.js';
import { imagenBlock } from './imagen.js';
export const blockRegistry = {
    // Fase 1
    'header': headerBlock,
    'hero': heroBlock,
    'content': contentBlock,
    'features': featuresBlock,
    'pricing': pricingBlock,
    'testimonials': testimonialsBlock,
    'stats': statsBlock,
    'faq': faqBlock,
    'footer': footerBlock,

    // Fase 2
    'cta-bar': ctaBarBlock,
    'countdown': countdownBlock,

    // Fase 3
    'maps': mapsBlock,
    'logos': logosBlock,
    'catalogo': catalogoBlock,
    'team': teamBlock,
    'timeline': timelineBlock,
    'video': videoBlock,
    'before-after': beforeAfterBlock,

    // Fase 4 — Bloques Premium
    'gallery': galleryBlock,
    // Banda rotativa full-width (imagen + titular + CTA por diapositiva). Puede ocupar
    // el puesto del hero: ver TIPOS_HERO en core/render.js.
    'carrusel': carruselBlock,
    // Imagen suelta como sección (una foto, botón opcional). Hermana del carrusel pero
    // sin rotación ni estado: la pieza única que ningún otro bloque cubría.
    'imagen': imagenBlock,
    'process': processBlock,
    'banner': bannerBlock,
    'comparison': comparisonBlock,
    'bento': bentoBlock,

    // Track B (visual) — Ola 1.3
    'journey': journeyBlock,

    // Bloque libre (HTML/CSS/JS en iframe sandbox). Solo inserción manual desde
    // el editor; la IA del generador de sitios NO puede producirlo.
    'ai-custom': aiCustomBlock,

    // Bloques de negocio (form/menu/services)
    'form': formBlock,
    'menu': menuBlock,
    'services': servicesBlock,

    // Quick-wins: reservas (form especializado), trust badges, reseñas + microdata
    'reservas': reservasBlock,
    // Reserva EN VIVO: asistente de 3 pasos contra el motor del ERP (lectura y escritura).
    // Convive con 'reservas' a propósito: aquel sigue siendo el formulario simple por defecto.
    'reserva-live': reservaLiveBlock,
    'entradas': entradasBlock,
    'trust': trustBlock,
    'reviews': reviewsBlock,

    // Tienda online (handoff 06-10-2026): datos VIVOS por visitante, sin nada guardado en el
    // bloque. Se insertan desde la tarjeta «Tienda» del catálogo (editor/tienda-panel.js).
    'ofertas': ofertasBlock,
    'novedades': novedadesBlock,
    'top': topBlock,
    'habitual': habitualBlock,
};

// 3.5: Single Source of Truth — lista canónica de tipos
export const BLOCK_TYPES = Object.keys(blockRegistry);
